<app-kd-solution
  [vm]="vm()"
  (reportSolvedEvent)="solveReport()"
  (reportEscalationEvent)="handleEscalationEvent($event)"
  (reportDeletedEvent)="deleteReport($event)"
  (reportSolutionSelectedEvent)="selectReportSolution($event)"
></app-kd-solution>
